<p>{{ message | async }}</p>
